export const baseUrlDev = "https://t-adria.com/api/";
export const baseUrlProd = "https://t-adria.com/api/";
export const providerName = "https://arenaxui.fastcloudnetwork.com:25463";
export const gaTrackingCode = "UA-175511762-2";
export const reskinName = "adria";
export const demo = false;
